'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.pageTransition = twentyninetimes.pageTransition || function () {

	function init() {
		siteAnchors();
	}

	function siteAnchors() {
        // Page transition
        var page_transition_overlay = document.querySelector('.page-transition-overlay');

        if ( page_transition_overlay ) {
            var siteDomain  = window.location.hostname,
                siteLinks   = document.querySelectorAll('a');

            siteLinks.forEach(link => {
                link.addEventListener('click', function(e) {
                    var link_url    = this.getAttribute('href'),
                        attr_blank  = this.getAttribute('target'),
                        has_domain  = link_url.includes(siteDomain),
                        cat_domain  = link_url.includes('/category/');

                    if ( has_domain && attr_blank != '_blank' && !cat_domain ) {
                        e.preventDefault();

                        pageTransitionOut(page_transition_overlay);

                        setTimeout(function() {
                            window.location.href = link_url;
                        }, 850);
                    }
                });
            });
        } else {
            anime({
                targets: '.blocks-container .container-inside > .wp-block-group h1 > span > span, .blocks-container .container-inside > .wp-block-cover h1 > span > span',
                translateY: ['100%', 0],
                delay: anime.stagger(50, {start: 200}),
                easing: 'easeOutQuart',
                loop: false,
                duration: 1250
            });

            anime({
                targets: '.blocks-container .container-inside > .wp-block-group h1 ~ p.has-preamble-font-size, h1 ~ p.has-preamble-font-size ~ .wp-block-buttons',
                opacity: [0, 1],
                translateY: [20, 0],
                delay: anime.stagger(100, {start: 850}),
                easing: 'easeOutQuart',
                loop: false,
                duration: 1500
            });
        }
    }

    function pageTransitionOut(overlay) {
        overlay.classList.add('active');

        anime({
            targets: '.page-transition-overlay__logo .path',
            opacity: [0, 1],
            translateY: [-60, 0],
            delay: anime.stagger(30, {start: 300}),
            loop: false,
            duration: 850
        });
    }

    function pageTransitionIn() {
        var page_transition_overlay = document.querySelector('.page-transition-overlay');

        if ( page_transition_overlay ) {
            page_transition_overlay.classList.add('done');
            page_transition_overlay.classList.remove('active');

            setTimeout(function() {
                page_transition_overlay.classList.remove('done');
            }, 750);

            anime({
                targets: '.blocks-container .container-inside > .wp-block-group h1 > span > span, .blocks-container .container-inside > .wp-block-cover h1 > span > span',
                translateY: ['100%', 0],
                delay: anime.stagger(50, {start: 200}),
                easing: 'easeOutQuart',
                loop: false,
                duration: 1250
            });

            anime({
                targets: '.blocks-container .container-inside > .wp-block-group h1 ~ p.has-preamble-font-size, h1 ~ p.has-preamble-font-size ~ .wp-block-buttons',
                opacity: [0, 1],
                translateY: [20, 0],
                delay: anime.stagger(100, {start: 850}),
                easing: 'easeOutQuart',
                loop: false,
                duration: 1500
            });
        }
    }

	return {
		init : init,
        siteAnchors : siteAnchors,
        pageTransitionIn : pageTransitionIn
	};

}();